var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showChat)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h2',[_vm._v("Chat")]),_vm._v(" "),(_vm.iframeSrc)?_c('iframe',{staticStyle:{"border":"none"},attrs:{"src":_vm.iframeSrc,"width":"100%","height":"400"}}):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3efcf8bd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chat.vue
// module id = null
// module chunks = 